<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gvlJy5/tc-custom/9781504042307.jpg?1734099135082" alt="This image is the cover for the book Financier, The Trilogy of Desire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Financier, The Trilogy of Desire
      </h1>
      <p class="bookDescription body article font2">
        <b>A nuanced portrait of one of the greatest characters in twentieth-century literature. </b><br/><br/> Based on the life of railway tycoon Charles Tyson Yerkes, the epic narrative spans from the aftermath of the Civil War to the Great Chicago Fire and the Panic of 1873. Both a glimpse of a fascinating period in American history and a timeless portrait of the dark side of human nature, this is the compelling tale the<i> Wall Street Journal</i> hailed as “the greatest of all American business novels . . . [with] an amazingly intricate description of high-rolling 19th-century finance.”<br/>  <br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Theodore Dreiser
      </h2>
      
      <p class="authorDescription body article">The Indiana-born Dreiser (1871-1945) has never cut a dashing or romantic swath through American literature. He has no Pulitzer or Nobel Prize to signify his importance. Yet he remains for myriad reasons: his novels are often larger than life, rugged, and defy the norms of conventional morality and organized religion. They are unapologetic in their sexual candor--in fact, outrightly frank--and challenge even modern readers. The brooding force of Dreiser&#8217;             s writing casts a dark shadow across American letters. Here in&amp;lt;i&amp;gt;An American Tragedy&amp;lt;/i&amp;gt;, Dreiser shows us the flip side of The American Dream in a gathering storm that echoes with all of the power and force of Dostoevsky&#8217;             s &amp;lt;i&amp;gt;Crime and Punishment&amp;lt;/i&amp;gt;. Inspired by the writings of Balzac and the ideas of Spenser and Freud, Dreiser went on to become one of America&#8217;             s best naturalist writers. &amp;lt;i&amp;gt;An American Tragedy&amp;lt;/i&amp;gt; is testimony to the strength of Dreiser&#8217;             s work: it retains all of its original intensity and force.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e04568a4